import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import IndexSectionNavigations13 from "../components/navigations/IndexSectionNavigations13";
import IndexSectionFooters7 from "../components/footers/IndexSectionFooters7";

const meta = {
  title: "利用規約 | らくらくQRシステム",
  meta: [
    {
      name: "description",
      content:
        "利用規約 - らくらくQRシステムの利用条件や規約を掲載しています。",
    },
  ],
};

export default function TOS() {
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta} />
      </HelmetProvider>
      <IndexSectionNavigations13 />
      <main>
        {/* ヒーローセクション */}
        <section className="relative pt-24">
          <div className="container px-4 mx-auto">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="font-heading text-5xl xs:text-6xl md:text-5xl font-bold text-gray-900 mb-4">
                利用規約
              </h1>
              <p className="mt-4 text-lg text-gray-600">
                らくらくQRシステムのご利用にあたっての重要な条件についてご確認ください。
              </p>
            </div>
          </div>
        </section>

        {/* 規約詳細セクション */}
        <section className="py-16 bg-white">
          <div className="container px-4 mx-auto max-w-4xl">
            <div className="space-y-12">
              <div className="p-8 rounded-xl shadow-sm hover:shadow-lg transition-shadow duration-300">
                <h2 className="text-2xl font-bold text-gray-800">
                  第1条（適用）
                </h2>
                <p className="text-gray-600 leading-relaxed">
                  本利用規約は、らくらくQRシステム（以下「当サービス」といいます）の利用条件及びルールを定めるものです。利用者は、本サービスを利用することにより、当規約に同意したものとみなされます。
                </p>
              </div>
              <div className="p-8 rounded-xl shadow-sm hover:shadow-lg transition-shadow duration-300">
                <h2 className="text-2xl font-bold text-gray-800">
                  第2条（会員登録）
                </h2>
                <p className="text-gray-600 leading-relaxed">
                  当サービスの機能は会員登録が必要です。会員登録を行うことで、利用者はより円滑にサービスを利用でき、専用のサポートも受けることができます。
                </p>
              </div>
              <div className="p-8 rounded-xl shadow-sm hover:shadow-lg transition-shadow duration-300">
                <h2 className="text-2xl font-bold text-gray-800">
                  第3条（禁止事項）
                </h2>
                <ul className="list-disc list-inside text-gray-600 leading-relaxed space-y-2">
                  <li>法令に違反する行為</li>
                  <li>当社または第三者の権利を侵害する行為</li>
                  <li>公序良俗に反する行為</li>
                  <li>その他、当社が不適切と判断する行為</li>
                </ul>
              </div>
              <div className="p-8 rounded-xl shadow-sm hover:shadow-lg transition-shadow duration-300">
                <h2 className="text-2xl font-bold text-gray-800">
                  第4条（サービスの変更・中断）
                </h2>
                <p className="text-gray-600 leading-relaxed">
                  当社は利用者への事前通知なく、サービス内容の変更または一時中断を行う場合があります。これにより発生した損害については、当社は一切の責任を負いません。
                </p>
              </div>
              <div className="p-8 rounded-xl shadow-sm hover:shadow-lg transition-shadow duration-300">
                <h2 className="text-2xl font-bold text-gray-800">
                  第5条（免責事項）
                </h2>
                <p className="text-gray-600 leading-relaxed">
                  当社は、本サービスの利用により発生したいかなる損害に対しても、原則として責任を負いかねます。利用者は自己の責任において本サービスをご利用ください。
                </p>
              </div>
              <div className="p-8 rounded-xl shadow-sm hover:shadow-lg transition-shadow duration-300">
                <h2 className="text-2xl font-bold text-gray-800">
                  第6条（準拠法・裁判管轄）
                </h2>
                <p className="text-gray-600 leading-relaxed">
                  本規約は日本法に準拠し、本規約から生じる一切の紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <IndexSectionFooters7 />
    </React.Fragment>
  );
}
